'use strict';

// ConfigData service
angular.module('core').factory('ConfigData', [
	function() {
		return window.config;
	}
]);
